import Chatscreen from "./chatArea";

export default Chatscreen;